export default "__VITE_ASSET__f75c527c__"